import React from 'react'
import SearchCategory from './SearchCategory'
import SearchBar from "./SearchBar";
import NavBar from "./Navbar";
import Dock from "./dock";


class SearchHome extends React.Component{
    constructor(props) {
        super(props);
        // if predefinedSearchCat is not set, default search-cat to 'anime'
        let predefinedSearchCat = localStorage.getItem('search-cat') || 'anime'
        this.state = {
            //this guarantee if user not select a category in SearchCategory
            //it will pick search anime by default
            selectValue: predefinedSearchCat
        }
    }

    handleSelectValue = state => {
        this.setState(state);
    }

    render() {
        return (
            <div id="wrapperNeue" className="wrapperNeue">
            <NavBar/>
                <div id="main" className="png_bg">
                <SearchCategory liftState={this.handleSelectValue} predefinedSearchCat={this.state.selectValue}/>
                {/*selectValue here would only change, if click on SearchCategory component,
                 otherwise selectValue keep original value set in constructor*/}
                <SearchBar cat={this.state.selectValue}/>
                </div>
                <div className="f"></div>
                <Dock/>
            </div>
        );
    }
}

export default SearchHome